import React from 'react';

import {connect} from 'react-redux';
import {submit, isSubmitting} from 'redux-form';

import {MODALS} from 'ducks/frontDesk';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';
import {RoomInspectionPassForm} from './components';

import './styles.css';

class RoomInspectionPassModal extends React.Component<any> {
  getExtraActions = () => {
    return [
      ...this.props.closeModalExtraActions,
      ...this.props.data.confirmExtraActions
    ];
  };

  render() {
    const {
      closeModal,
      form: {submitting},
      data: {bookingId, locationRef, allocationId},
      submit
    } = this.props;

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={Modal.EXTRA_SMALL}
        className="RoomInspectionPassModal">
        <Modal.Header heading="Room inspection" />
        <Modal.Body>
          <RoomInspectionPassForm
            getExtraActions={this.getExtraActions}
            locationRef={locationRef}
            bookingId={bookingId}
            allocationId={allocationId}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={submitting}
            blue={!submitting}
            isLoading={submitting}
            onClick={() => submit('roomInspectionPass')}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapDispatchToProps = {submit};

const mapStateToProps = state => ({
  form: {
    submitting: isSubmitting('roomInspectionPass')(state)
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withModal(MODALS.ROOM_INSPECTION_PASS)(RoomInspectionPassModal)
);
